<template>
  <form @submit.prevent="handleSubmit">
    <table class="table table-striped m-0">
      <thead>
      <tr>
        <th></th>
        <th>Modulname</th>
        <th style="text-align: right">Einheiten</th>
        <th style="text-align: right">Bestellnummer</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="module in privateCoachingModules" :key="module.id">
        <td>
          <input
              type="checkbox"
              v-model="selectedModuleIds"
              :value="module.id"
              class="checkbox"
          />
        </td>
        <td>
          <strong class="js-lists-values-employee-name">
            {{ module.name }}
          </strong>
        </td>
        <td style="text-align: right;">
          <strong class="js-lists-values-employee-name">
            {{ module.units }}
          </strong>
        </td>
        <td style="text-align: right;">
          <strong class="js-lists-values-employee-name">
            {{ module.orderNumber }}
          </strong>
        </td>
      </tr>
      </tbody>
    </table>
    <input type="hidden" :value="privateCoachingId" name="privateCoachingId"/>

    <div class="mt-5 mr-1 text-center">
      <button type="submit" class="btn btn-primary">Genehmigen</button>
    </div>
  </form>
</template>

<script setup>
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { defineEmits, defineProps, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const isLoaded               = ref(false);
const isSubmitting           = ref(false);
const privateCoachingModules = ref([]);
const selectedModuleIds      = ref([]);
const emit                   = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  unemployedId: {
    type: Number,
    required: true,
  },
  privateCoachingId: {
    type: Number,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

async function handleSubmit() {
  try {
    if (isSubmitting.value) return;
    isSubmitting.value = true;

    await privateCoachingService.approveModules(selectedModuleIds.value, props.privateCoachingId);

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getPrivateCoachingData(privateCoachingId) {
  try {
    CloseToast();
    const { data }               = await privateCoachingService.getPrivateCoaching(privateCoachingId);
    privateCoachingModules.value = data.data?.modules || [];

    selectedModuleIds.value = privateCoachingModules.value.filter((module) => module.isApproved)
                                                    .map((module) => module.id);
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (props.privateCoachingId) {
    await getPrivateCoachingData(props.privateCoachingId);
  }

  isLoaded.value = true;
});
</script>

<style scoped>

</style>